
<script lang="ts">
  import { Plus } from 'phosphor-svelte';
  import { css } from '@agapi/ui/panda/css';

  import { accordionStyles} from '../accordion-styles';
  import { useAccordionContext } from '../use-accordion-context';
  import { useAccordionItemContext } from '../use-accordion-item-context';
  import type { AccordionTriggerProps } from '../accordion.types';

  const { showIndicator = true, css: cssProps,...itemProps }: AccordionTriggerProps = $props();
  const classes = accordionStyles.raw();
  const accordion = useAccordionContext();
  const { title } = useAccordionItemContext();
</script>

<h3>
  <button
    {...accordion.api.getItemTriggerProps({ value: title, ...itemProps })}
    class={css(classes.itemTrigger, cssProps)}
  >
    {title}
    {#if showIndicator}
      <div {...accordion.api.getItemIndicatorProps({ value: title })} class={css(classes.itemIndicator)}>
        <Plus style="bold" />
      </div>
    {/if}
  </button>
</h3>
